export const CELL_DIRECTIONS = {
  TOP: 'TOP' as const,
  RIGHT: 'RIGHT' as const,
  BOTTOM: 'BOTTOM' as const,
  LEFT: 'LEFT' as const,
} as const;

/**
 * If we want to enable support for resizing rows we need to
 * add TOP and BOTTOM directions here and add support in computeCell.
 */
export const DRAG_DIRECTIONS = {
  LEFT: 'LEFT' as const,
  RIGHT: 'RIGHT' as const,
} as const;

export const NEW_CELL_PREFIX = 'new_cell_';

export const LAYOUT_AXIS = {
  rows: {
    key: 'rows',
    trackType: 'row',
    label: 'Rows',
    property: 'gridTemplateRows',
    // This is the default size of a row
    value: 'auto',
  },
  columns: {
    key: 'columns',
    trackType: 'column',
    label: 'Columns',
    property: 'gridTemplateColumns',
    // This is the default size of a column
    value: '1fr',
  },
} as const;

export const AXIS_ACTIONS = {
  ADD: 'ADD' as const,
  REMOVE: 'REMOVE' as const,
  RESIZE: 'RESIZE' as const,
  TOGGLE_SIZE_MODE: 'TOGGLE_SIZE_MODE' as const,
} as const;

export const LAYOUT_CONTEXT_MENU_ITEMS = [
  {
    label: 'column',
    subMenu: [
      {
        label: 'Left',
        direction: 'LEFT',
      },
      {
        label: 'Right',
        direction: 'RIGHT',
      },
    ],
  },
  {
    label: 'row',
    subMenu: [
      {
        label: 'Above',
        direction: 'TOP',
      },
      {
        label: 'Below',
        direction: 'BOTTOM',
      },
    ],
  },
] as const;
